module.exports = __webpack_public_path__ + "static/icons/icon-menu-c569d3bceb844e49b00e1d1e8ab2b062.svg";